export default function TobaccoUseExtended() {
  return [
      { label: "Within the last year", value: "Within the last year" },
      { label: "Within the last 13-36 months", value: "Within the last 13-36 months" },
      { label: "Over 36 months ago", value: "Over 36 months" },
      { label: "Never", value: "Never" },
  ]
};